import React from "react";
import { useDispatch } from "react-redux";
import {
  archiveUserAction,
  showErrorMessage,
  showSuccessMessage,
} from "../../../../actions";
import ActionDialog from "../../ActionDialog";
import { Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { resolveErrorMessage } from "../../../../util";

import LoadingSpinner from "../../LoadingSpinner";

const ArchiveUserDialog = ({ open, onClose, user, onComplete }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const archiveUser = async () => {
    setLoading(true);
    try {
      await archiveUserAction({ editedUserId: user.id });
      dispatch(showSuccessMessage("app.user.hasBeenArchived"));
      await onComplete();
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <ActionDialog
      title="app.confirmations"
      open={open}
      onAccept={archiveUser}
      onClose={onClose}
      maxWidth="xs"
      disableConfirmButton={loading}
    >
      {loading ? (
        <LoadingSpinner
          message={<FormattedMessage id="app.loading.updating" />}
        />
      ) : (
        <>
          <Typography variant="body1" paragraph>
            <FormattedMessage id="app.confirmations.archiveUser" />
          </Typography>
          <Typography variant="body1" paragraph>
            <FormattedHTMLMessage id="app.action.cannotBeUndone" />
          </Typography>
        </>
      )}
    </ActionDialog>
  );
};
export default React.memo(ArchiveUserDialog);
